import React from 'react';
import './SplashScreen.css';

export default function SplashScreen() {
  return (
    <div className="splash">
      <div className="splash-content">
        <div className="splash-logo">🌿</div>
        <h1 className="splash-brand">FreshMart</h1>
        <p className="splash-tagline">Farm Fresh · Delivered Fast</p>
        <div className="splash-loader">
          <div className="splash-bar" />
        </div>
      </div>
      <div className="splash-emojis">
        {['🍎','🥦','🥛','🍞','🥩','🧃','🌿','🍋','🫐','🥕'].map((e,i)=>(
          <span key={i} style={{ animationDelay:`${i*0.18}s` }}>{e}</span>
        ))}
      </div>
    </div>
  );
}
